module.exports = __webpack_public_path__ + "static/visionar_augmented_reality_ar-trends_792-352-7c63ad7f1e6859ca719b8e85e4f8b273.jpg";